// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/style.css'
import utils from './utils/public.js'
import LuckDraw from 'vue-luck-draw'
import scroll from 'vue-seamless-scroll'
import axios from 'axios'
import api from './api/index.js'
import VueCookies from 'vue-cookies'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css';
import '../node_modules/social-share.js/dist/js/social-share.min.js'
import VueI18n from 'vue-i18n'


Vue.use(ElementUI);
Vue.use(LuckDraw)
Vue.use(VueCookies)
Vue.use(scroll)
Vue.use(Share)
Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.prototype.utils = utils
Vue.prototype.api = api


axios.interceptors.response.use(function (response) {
  if (response.data.code == 3) {
    $cookies.set('token', '')
    $cookies.set('userInfo', '')
    router.push({
      path: '/',
      query: {
        status: 1
      }
    })
  }
  return response;
}, function (error) {
  return Promise.reject(error);
})
const i18n = new VueI18n({
  //定义默认语言
  locale: 'cn',
  messages: {
    'cn': require('./common/lang/cn'),
    'en': require('./common/lang/en')
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})


//npm install socket.io-client --save



// WEBPACK FOOTER //
// ./src/main.js